// extracted by mini-css-extract-plugin
export default {"policyTemplates":"policyTemplates___w4KtH","policyTemplate":"policyTemplate___gThDf"};